<template>
    <div class="subscriptions-wrapper">
        <toggle-subject
            v-for="(subscription, index) in subscriptions.items"
            :key="index"
            v-model="mySubscriptions"
            :subscription="subscription"
        ></toggle-subject>
    </div>
</template>

<script>
import toggleSubject from '@/components/form/toggle-subject';
export default {
    components: {
        toggleSubject
    },
    props: {
        subscriptions: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            firstLoad: true,
            allNews: [],
            allThemes: [],
            myNews: [],
            myThemes: [],
            mySubscriptions: {}
        };
    }
};
</script>
